import React from "react";
import Card from "react-bootstrap/Card";

/**
 * This displays the second pass transcription stats and allows for requesting a transcript to give a second pass transcription
 * @memberof qa-world.components
 * @alias IndexSecondPassTranscriptionQueue
 */

const IndexSecondPassTranscriptionQueue = ({
  queueLength,
  inProgressCount,
  currentlyTranscribing,
  completedToday,
}) => {
  const callsText = `gold call${completedToday === 1 ? "" : "s"}`;

  let queue;
  if (queueLength === 0) {
    queue = (
      <p className="alert alert-success">
        There are no gold calls at this time, please check back later.
      </p>
    );
  } else {
    queue = (
      <>
        <p className="alert alert-warning">
          {inProgressCount} / {queueLength} gold call transcripts in queue are
          being transcribed
        </p>
        {currentlyTranscribing !== 0 && (
          <a
            className="mt-4 btn btn-primary"
            href="/transcriptions/second_pass/claim_call"
          >
            Continue Transcribing
          </a>
        )}
        {currentlyTranscribing === 0 && inProgressCount < queueLength && (
          <a
            className="mt-4 btn btn-primary"
            href="/transcriptions/second_pass/claim_call"
          >
            Transcribe a gold call
          </a>
        )}
      </>
    );
  }
  let successMessage;
  if (completedToday > 0) {
    successMessage = (
      <p>
        You have transcribed {completedToday} {callsText} today.
      </p>
    );
  }

  return (
    <Card body>
      <h5 className="large">Gold Call Transcription Queue </h5>
      {successMessage}
      {queue}
    </Card>
  );
};

export default IndexSecondPassTranscriptionQueue;
